export const ROOT = '/';
export const MAKER = '/maker';
export const DONATE_THANKS = '/donate-thanks';
export const MAKER_V2 = '/v2/maker';
